var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"list-unstyled subnav-nav"},[_c('li',{staticClass:"subnav-nav--item"},[_c('router-link',{staticClass:"py-1 overview",attrs:{"to":{ name: 'dashboard.batch.list' }}},[_vm._v("Overview")])],1),_vm._l((_vm.openTasks),function(task){return _c('li',{key:task.type,staticClass:"subnav-nav--item"},[_c('router-link',{staticClass:"py-1",attrs:{"to":{
          name: 'dashboard.batch.type',
          params: { type: task.type }
        }}},[_vm._v(_vm._s(_vm.$t(`batch.type.${task.type}`) + ` (${task.count})`))])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }